import React from "react";
import { NavLink } from "react-router-dom";
import { Nav } from "reactstrap";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import UserService from "../../services/UserService";
import { GROUP_PERMISSIONS } from "../../constants/GroupPermission";

// import logo from "logo.svg";

var ps;

class Sidebar extends React.Component {
	constructor(props) {
		super(props);
		this.activeRoute.bind(this);
		this.sidebar = React.createRef();
	}
	// verifies if routeName is the one active (in browser input)
	activeRoute(routeName) {
		return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
	}
	componentDidMount() {
		if (navigator.platform.indexOf("Win") > -1) {
			ps = new PerfectScrollbar(this.sidebar.current, {
				suppressScrollX: true,
				suppressScrollY: false
			});
		}
	}
	componentWillUnmount() {
		if (navigator.platform.indexOf("Win") > -1) {
			ps.destroy();
		}
	}
	render() {
		return (
			<div
				className="sidebar"
				data-color={this.props.bgColor}
				data-active-color={this.props.activeColor}
			>
				<div className="logo">
					<a href="/admin/dashboard" className="simple-text logo-mini">
						<div className="logo-img">
							<img src="/img/logo.png" alt="ahia logo" />
						</div>
					</a>
					<a href="/admin/dashboard" className="simple-text logo-normal">
						{UserService.get().first_name
							? UserService.get().first_name
							: "User"}
					</a>
				</div>
				<div className="sidebar-wrapper" ref={this.sidebar} style={{overflow: "hidden"}}>
					<Nav>
						{this.props.routes.map((prop, key) => {
							const isAdmin = prop.admin;
							return isAdmin ? (
								UserService.get().GroupPermission.id ===
									GROUP_PERMISSIONS.superAdmin.id && (
									<li
										className={
											this.activeRoute(prop.path) +
											(prop.pro ? " active-pro" : "")
										}
										key={key}
									>
										<NavLink
											to={prop.layout + prop.path}
											className="nav-link"
											activeClassName="active"
										>
											<i className={prop.icon} />
											<p>{prop.name}</p>
										</NavLink>
									</li>
								)
							) : (
								<li
									className={
										this.activeRoute(prop.path) +
										(prop.pro ? " active-pro" : "")
									}
									key={key}
								>
									<NavLink
										to={prop.layout + prop.path}
										className="nav-link"
										activeClassName="active"
									>
										<i className={prop.icon} />
										<p>{prop.name}</p>
									</NavLink>
								</li>
							);
						})}
					</Nav>
				</div>
			</div>
		);
	}
}

export default Sidebar;
